import styled from 'styled-components';
import {
  Button,
  ButtonAsLinkVariant,
  ButtonVariant,
  spacingHelper,
  typographyHelper,
} from '@property.com.au/ui-kit';
import { FunctionComponent, useState } from 'react';
import { trackDisclaimerModalOpen } from '../../../analytics/event-tracking/trackDisclaimerModalOpen';
import { DisclaimerIcon } from '../../../app-kit/components/DisclaimerIcon/DisclaimerIcon';
import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { useSuburbPageModalContext } from '../../contexts/SuburbPageModalContext/SuburbPageModalContext';
import { School } from '../../../components/SchoolsAccordionTable/types';
import { SchoolsAccordionTable } from '../../../components/SchoolsAccordionTable/SchoolsAccordionTable';

interface SuburbPageNearbySchoolsBrickProps {
  title: string;
  visible: School[];
  hidden?: School[] | null;
  schoolFactHeader: string[];
  showAllButton?: { text: string; variant: ButtonVariant | ButtonAsLinkVariant } | null;
}

const ShowAllButton = styled(Button)`
  ${typographyHelper('overline')};
  display: block;
  margin: ${spacingHelper('large auto extraSmall')};
`;

export const SuburbPageNearbySchoolsBrick: FunctionComponent<SuburbPageNearbySchoolsBrickProps> = ({
  title,
  visible,
  hidden,
  schoolFactHeader,
  showAllButton,
}) => {
  const { displayModal } = useSuburbPageModalContext();
  const [hideExtraSchools, setHideExtraSchools] = useState<boolean>(Boolean(hidden));
  const hiddenSchools = hidden || [];
  const schoolsToShow: School[] = hideExtraSchools ? visible : [...visible, ...hiddenSchools];

  return (
    <ContentBrick
      title={title}
      headerChildren={
        <DisclaimerIcon
          title="Open Nearby Schools Disclaimer"
          onClick={() => {
            displayModal({ name: 'nearbySchoolsDisclaimer' });
            trackDisclaimerModalOpen({
              inPageSource: 'suburb_page__nearby_schools_brick___disclaimer_link',
            });
          }}
        />
      }
    >
      <SchoolsAccordionTable schools={schoolsToShow} schoolFactHeader={schoolFactHeader} />
      {showAllButton && hideExtraSchools && (
        <ShowAllButton
          onClick={() => {
            setHideExtraSchools(false);
          }}
          variant={showAllButton.variant}
        >
          {showAllButton.text}
        </ShowAllButton>
      )}
    </ContentBrick>
  );
};
